import { createSelector } from "@ngrx/store";

import { selectModelsById } from "src/app/state/helpers/select-models-by-id";
import { State } from "src/app/state/interfaces";

import { HOLIDAYS_FEATURE_KEY, MANAGER_FEATURE_KEY } from "../interfaces";

const state = (s: State) => s[MANAGER_FEATURE_KEY][HOLIDAYS_FEATURE_KEY];

export const selectHolidays = createSelector(state, ({ models, holidays }) => selectModelsById(models, holidays));